// Opens a centered popup window over the app (like the Facebook share
// dialog). Reuses the same named window so repeated group posts recycle it.
export function openSharePopup(url, name = "firewatch-share", w = 1000, h = 720) {
  const width = Math.min(w, window.screen.availWidth - 40);
  const height = Math.min(h, window.screen.availHeight - 60);
  const left = window.screenX + Math.max(0, (window.outerWidth - width) / 2);
  const top = window.screenY + Math.max(0, (window.outerHeight - height) / 2);
  const win = window.open(
    url,
    name,
    `popup=yes,width=${width},height=${height},left=${left},top=${top},noopener`,
  );
  if (win) win.focus();
  return win;
}
